// extracted by mini-css-extract-plugin
module.exports = {"table":"reportAdminDetail_table__Kw30i","hidden":"reportAdminDetail_hidden__3ocSo"};